module.exports = __webpack_public_path__ + "img/sumj_logo.0d67663a.png";